"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtensionRegistry = void 0;
const lodash_1 = require("lodash");
class ExtensionRegistry {
    constructor() {
        this._drawerTabs = [];
    }
    registerDrawerTab(drawerTab) {
        const keyedTabs = lodash_1.mapKeys(this._drawerTabs, tab => tab.getTabId());
        const uniqueTabs = Object.assign(Object.assign({}, keyedTabs), { [drawerTab.getTabId()]: drawerTab });
        this._drawerTabs = lodash_1.sortBy(lodash_1.values(uniqueTabs), ({ order }) => order);
    }
    getDrawerTabs() {
        return this._drawerTabs;
    }
}
exports.ExtensionRegistry = ExtensionRegistry;
const theRegistry = new ExtensionRegistry();
exports.default = theRegistry;
